/*
 * @author: songhlc
 * @date: 2018-03-05
 * @description: 详情显示组件
 * */
import template from './index.html'
import ko from 'knockout'
import 'ko-bindinghandler'
import Base from '../../core/base'
import getLang from '../../i18n'
class Showdetail extends Base {
  initialize (params) {
    this.text = params.text
    // 在某些场景下，希望默认用于显示的字符和tooltip中显示的不一样，这里希望可以自定义
    // 添加textShow参数 以及适配原来的limitText
    this.textShow = params.textShow || params.limitText || params.text
    this.visible = ko.observable(false)
    this.multiple = !!params.multiple
    this.title = getLang('详细')
  }
  computed (params) {
    this.style = ko.computed(() => {
      let style = {}
      if (this.visible()) {
        style.marginRight = '33px'
      }
      return style
    })
  }
  subscribe (params) {
    if (ko.isObservable(this.text)) {
      this.text.subscribe(val => {
        this.computedVisible()
      })
    }
  }
  methods (params) {
    this.computedVisible = () => {
      ko.tasks.schedule(function () {
        var el = this.$el
        if (!this.multiple) {
          var scrollWidth = el.children[0].children[0].scrollWidth
          var offsetWidth = el.children[0].children[0].offsetWidth
          // 有隐藏
          if (scrollWidth > offsetWidth) {
            this.visible(true)
          } else {
            this.visible(false)
          }
        } else {
          var scrollHeight = el.children[0].children[0].scrollHeight
          var offsetHeight = el.children[0].children[0].offsetHeight
          // 有一些机器srollHeight比offsetHeight高1px 加大判断的值
          if (scrollHeight - offsetHeight > 8) {
            this.visible(true)
          } else {
            this.visible(false)
          }
        }
      }.bind(this))
    }
  }
  created (params) {
    this.computedVisible()
  }
}
export default {
  name: 'showdetail',
  init: Base.createViewModel(Showdetail),
  template
}



// WEBPACK FOOTER //
// ./src/components/showdetail/index.js